import { render } from "./NotifyUser.vue?vue&type=template&id=738bb06b&scoped=true"
import script from "./NotifyUser.vue?vue&type=script&lang=js"
export * from "./NotifyUser.vue?vue&type=script&lang=js"

import "./NotifyUser.vue?vue&type=style&index=0&id=738bb06b&lang=css"
import "./NotifyUser.vue?vue&type=style&index=1&id=738bb06b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-738bb06b"]])

export default __exports__